import React, { useState } from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';
import { SectionHeader } from '@/components/SectionHeader';
import { Button } from '@/components/ui/button';
import { Lightbulb, ShieldOff, MessageCircle } from 'lucide-react';

// Lazy load the content components
const IdeasBoardPage = React.lazy(() => import('./IdeasBoardPage'));
const AnonymousWallPage = React.lazy(() => import('./AnonymousWallPage'));
const CRMFeedbackPage = React.lazy(() => import('./CRMFeedbackPage'));

const tabs = [
  { key: 'ideas', label: 'Ideas Board', icon: Lightbulb, color: 'from-amber-500 to-orange-600' },
  { key: 'anonymous', label: 'Anonymous Wall', icon: ShieldOff, color: 'from-purple-500 to-pink-600' },
  { key: 'crm', label: 'CRM Feedback', icon: MessageCircle, color: 'from-blue-500 to-cyan-600' },
];

export default function IdeasFeedbackPage() {
  const [activeTab, setActiveTab] = useState('ideas');

  return (
    <ResponsiveLayout>
      <div className="flex-1 min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--text-primary))] p-4 lg:p-6">
        <SectionHeader
          icon={Lightbulb}
          title="Ideas & Feedback"
          subtitle="Share ideas, anonymous feedback, and CRM suggestions"
          iconBg="bg-gradient-to-br from-amber-500 to-orange-600 shadow-amber-500/20"
        />

        {/* Tab Navigation */}
        <div className="flex gap-2 mb-6 border-b border-[hsl(var(--border))] pb-3 overflow-x-auto">
          {tabs.map((tab) => (
            <Button
              key={tab.key}
              variant={activeTab === tab.key ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setActiveTab(tab.key)}
              className={activeTab === tab.key ? `bg-gradient-to-r ${tab.color} text-white border-0` : 'text-[hsl(var(--text-secondary))]'}
              data-testid={`tab-${tab.key}`}
            >
              <tab.icon size={14} className="mr-1.5" />
              {tab.label}
            </Button>
          ))}
        </div>

        {/* Tab Content */}
        <React.Suspense fallback={<div className="flex justify-center py-12"><div className="w-6 h-6 border-2 border-[hsl(var(--primary))] border-t-transparent rounded-full animate-spin" /></div>}>
          {activeTab === 'ideas' && <IdeasBoardPage embedded />}
          {activeTab === 'anonymous' && <AnonymousWallPage embedded />}
          {activeTab === 'crm' && <CRMFeedbackPage embedded />}
        </React.Suspense>
      </div>
    </ResponsiveLayout>
  );
}
